export const POPULATE_CATEGORY_DATA = 'locale/admin/bookings/POPULATE_CATEGORY_DATA';
export const POPULATE_COMBINED_TABLE_DATA = 'locale/admin/bookings/POPULATE_COMBINED_TABLE_DATA';
export const POPULATE_COMBINED_TABLE_META = 'locale/admin/bookings/POPULATE_COMBINED_TABLE_META';
export const SET_ARCHIVE_MODAL_OPEN = 'locale/admin/bookings/SET_ARCHIVE_MODAL_OPEN';
export const SET_ARCHIVE_MODAL_MESSAGE = 'locale/admin/bookings/SET_ARCHIVE_MODAL_MESSAGE';
export const SET_ARCHIVE_AMENITY_MODAL_OPEN = 'locale/admin/bookings/SET_ARCHIVE_AMENITY_MODAL_OPEN';
export const SET_ARCHIVE_AMENITY_MODAL_MESSAGE = 'locale/admin/bookings/SET_ARCHIVE_AMENITY_MODAL_MESSAGE';
export const SET_REACTIVATE_MODAL_OPEN = 'locale/admin/bookings/SET_REACTIVATE_MODAL_OPEN';
export const SET_SEARCH_TEXT = 'locale/admin/bookings/SET_SEARCH_TEXT';
export const SET_SEARCH_BLOCKS = 'locale/admin/bookings/SET_SEARCH_BLOCKS';
export const SET_IS_LOADING = 'locale/admin/bookings/SET_IS_LOADING';
export const SET_DELETE_CATEGORY_MODAL_OPEN = 'locale/admin/bookings/SET_DELETE_CATEGORY_MODAL_OPEN';

export const populateCategoryList = (data) => ({
    type: POPULATE_CATEGORY_DATA,
    payload: {
        data: data,
    }
})

export const populateCombinedTableList = (data) => ({
    type: POPULATE_COMBINED_TABLE_DATA,
    payload: {
        data: data,
    }
})

export const populateCombinedTableMeta = (data) => ({
    type: POPULATE_COMBINED_TABLE_META,
    payload: {
        data: data,
    }
})

export const setArchiveModalOpen = (data) => ({
    type: SET_ARCHIVE_MODAL_OPEN,
    payload: {
        data: data
    }
})

export const setArchiveModalMessage = (data) => ({
    type: SET_ARCHIVE_MODAL_MESSAGE,
    payload: {
        data: data
    }
})

export const setReactivateModalOpen = (data) => ({
    type: SET_REACTIVATE_MODAL_OPEN,
    payload: {
        data: data
    }
})

export const setArchiveAmenityModalOpen = (data) => ({
    type: SET_ARCHIVE_AMENITY_MODAL_OPEN,
    payload: {
        data: data
    }
})

export const setArchiveAmenityModalMessage = (data) => ({
    type: SET_ARCHIVE_AMENITY_MODAL_MESSAGE,
    payload: {
        data: data
    }
})

export const setSearchText = (data) => ({
    type: SET_SEARCH_TEXT,
    payload: {
        data: data
    }
})

export const setSearchBlocks = (data) => ({
    type: SET_SEARCH_BLOCKS,
    payload: {
        data: data
    }
})

export const setIsLoading = (loading) => ({
    type: SET_IS_LOADING,
    payload: loading,
});

export const setDeleteCategoryModalOpen = (data) => ({
    type: SET_DELETE_CATEGORY_MODAL_OPEN,
    payload: data,
});
